import React from "react";

function Footer() {
    return (
        <footer className="w-full bg-gray-800 text-gray-300 py-4 px-6 text-center">
            &copy; {new Date().getFullYear()} Swan Solutions. All rights reserved.
        </footer>
    );
}

export default Footer;
